export default "__VITE_ASSET__BOMAdD5I__"